module.exports = __webpack_public_path__ + "static/media/flag-alt.0919fabf.svg";